<script setup>
import { getI18n } from '@/plugins/i18n'

import { CHAT_PDF_MEDIA_TYPE } from '@/stores/chat.store'

defineProps({
  photo: {
    type: Object,
    required: true,
  },
  removable: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['open', 'remove'])

const i18n = getI18n()
</script>

<template>
  <div class="chat-photo-thumb">
    <div v-if="photo.media_type === CHAT_PDF_MEDIA_TYPE" class="chat-photo-thumb__image column flex-center">
      <q-icon name="mdi-file-pdf-box" size="md" color="grey-7" />
      <q-tooltip>{{ photo.name }}</q-tooltip>
    </div>
    <q-img
      v-else
      :src="photo.preview"
      class="chat-photo-thumb__image cursor-pointer"
      fit="cover"
      @click="emit('open', photo)"
    >
      <template #loading>
        <q-spinner color="primary" size="sm" />
      </template>
    </q-img>
    <q-btn
      v-if="removable"
      round
      unelevated
      size="0.5rem"
      color="grey-9"
      icon="mdi-close"
      class="chat-photo-thumb__remove"
      @click.stop="emit('remove', photo)"
    >
      <q-tooltip>{{ i18n.t('common.delete') }}</q-tooltip>
    </q-btn>
  </div>
</template>

<style scoped lang="scss">
.chat-photo-thumb {
  position: relative;
  display: inline-block;
}

.chat-photo-thumb__image {
  width: 4rem;
  height: 4rem;
  border-radius: .5rem;
  border: 1px solid $grey-4;
}

.chat-photo-thumb__remove {
  position: absolute;
  top: -.3125rem;
  right: -.3125rem;
}
</style>
